import { render, staticRenderFns } from "./expressData.vue?vue&type=template&id=b57a3964&scoped=true"
import script from "./expressData.vue?vue&type=script&lang=js"
export * from "./expressData.vue?vue&type=script&lang=js"
import style0 from "./expressData.vue?vue&type=style&index=0&id=b57a3964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57a3964",
  null
  
)

export default component.exports